define.alias("shared/components/shared/table-analytics", "calendar/components/shared/table-analytics");